/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NoticePeriodDurationDto } from './NoticePeriodDurationDto';
import {
    NoticePeriodDurationDtoFromJSON,
    NoticePeriodDurationDtoFromJSONTyped,
    NoticePeriodDurationDtoToJSON,
    NoticePeriodDurationDtoToJSONTyped,
} from './NoticePeriodDurationDto';
import type { TargetedSubscriberEnum } from './TargetedSubscriberEnum';
import {
    TargetedSubscriberEnumFromJSON,
    TargetedSubscriberEnumFromJSONTyped,
    TargetedSubscriberEnumToJSON,
    TargetedSubscriberEnumToJSONTyped,
} from './TargetedSubscriberEnum';

/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    logoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    branchId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    branchLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    fullDescription?: string;
    /**
     * Personne owning the product (same id as the personId of the product commands).
     * @type {string}
     * @memberof ProductDto
     */
    ownerId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    ownerName: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    activeContractsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    quotesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    isTacitRenewal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    isFixedFormula: boolean;
    /**
     * 
     * @type {TargetedSubscriberEnum}
     * @memberof ProductDto
     */
    targetedSubscriber: TargetedSubscriberEnum;
    /**
     * 
     * @type {NoticePeriodDurationDto}
     * @memberof ProductDto
     */
    noticePeriodDuration: NoticePeriodDurationDto;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProductDto
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductDto
     */
    lastModificationDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDto
     */
    plateformeIds: Array<string>;
}



/**
 * Check if a given object implements the ProductDto interface.
 */
export function instanceOfProductDto(value: object): value is ProductDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('branchId' in value) || value['branchId'] === undefined) return false;
    if (!('branchLabel' in value) || value['branchLabel'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('ownerName' in value) || value['ownerName'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('isTacitRenewal' in value) || value['isTacitRenewal'] === undefined) return false;
    if (!('isFixedFormula' in value) || value['isFixedFormula'] === undefined) return false;
    if (!('targetedSubscriber' in value) || value['targetedSubscriber'] === undefined) return false;
    if (!('noticePeriodDuration' in value) || value['noticePeriodDuration'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    return true;
}

export function ProductDtoFromJSON(json: any): ProductDto {
    return ProductDtoFromJSONTyped(json, false);
}

export function ProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'code': json['code'],
        'logoURL': json['logoURL'] == null ? undefined : json['logoURL'],
        'branchId': json['branchId'],
        'branchLabel': json['branchLabel'],
        'summary': json['summary'],
        'fullDescription': json['fullDescription'] == null ? undefined : json['fullDescription'],
        'ownerId': json['ownerId'],
        'ownerName': json['ownerName'],
        'activeContractsCount': json['activeContractsCount'],
        'quotesCount': json['quotesCount'],
        'isTacitRenewal': json['isTacitRenewal'],
        'isFixedFormula': json['isFixedFormula'],
        'targetedSubscriber': TargetedSubscriberEnumFromJSON(json['targetedSubscriber']),
        'noticePeriodDuration': NoticePeriodDurationDtoFromJSON(json['noticePeriodDuration']),
        'isActive': json['isActive'],
        'creationDate': (new Date(json['creationDate'])),
        'lastModificationDate': json['lastModificationDate'] == null ? undefined : (new Date(json['lastModificationDate'])),
        'plateformeIds': json['plateformeIds'],
    };
}

export function ProductDtoToJSON(json: any): ProductDto {
    return ProductDtoToJSONTyped(json, false);
}

export function ProductDtoToJSONTyped(value?: ProductDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'code': value['code'],
        'logoURL': value['logoURL'],
        'branchId': value['branchId'],
        'branchLabel': value['branchLabel'],
        'summary': value['summary'],
        'fullDescription': value['fullDescription'],
        'ownerId': value['ownerId'],
        'ownerName': value['ownerName'],
        'activeContractsCount': value['activeContractsCount'],
        'quotesCount': value['quotesCount'],
        'isTacitRenewal': value['isTacitRenewal'],
        'isFixedFormula': value['isFixedFormula'],
        'targetedSubscriber': TargetedSubscriberEnumToJSON(value['targetedSubscriber']),
        'noticePeriodDuration': NoticePeriodDurationDtoToJSON(value['noticePeriodDuration']),
        'isActive': value['isActive'],
        'creationDate': ((value['creationDate']).toISOString()),
        'lastModificationDate': value['lastModificationDate'] == null ? undefined : ((value['lastModificationDate']).toISOString()),
        'plateformeIds': value['plateformeIds'],
    };
}

